import { component } from 'picoapp';

export default component((node: HTMLSelectElement) => {
  const helperElement = document.querySelector<HTMLSpanElement>('[data-helper-element]');
  const sortTitle = node.querySelector<HTMLSpanElement>('[data-sort-title]');
  const sortModal = node.querySelector<HTMLDivElement>('[data-sort-modal]');

  function resize(width) {
    const root = document.documentElement;
    root.style.setProperty('--dynamic-size', `${width}px`);
  }

  function initResize(event) {
    const eventTarget = event.target as HTMLInputElement;
    helperElement.innerHTML = eventTarget.innerText;
    resize(helperElement.offsetWidth);
  }

  function handleSortChange(event: Event) {
    const eventTarget = event.target as HTMLInputElement;
    if (eventTarget && eventTarget.checked) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', eventTarget.value);
      sortTitle.innerHTML = eventTarget.getAttribute('data-sort-item');

      const sortEventTarget = new CustomEvent('collection:sort:apply', {
        detail: { url },
      });

      document.dispatchEvent(sortEventTarget);
    }
  }

  sortTitle.addEventListener('click', () => {
    sortModal.classList.remove('opacity-0', 'pointer-events-none');
  });

  document.addEventListener('click', (event) => {
    if (event.target !== sortTitle) {
      sortModal.classList.add('opacity-0', 'pointer-events-none');
    }
  });

  node.querySelectorAll('input[data-sort-item]').forEach((input) => {
    input.addEventListener('change', (event) => {
      handleSortChange(event);
      initResize(event);
    });
  });
});
